import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAppsignalComponent } from './simple-icons-appsignal.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAppsignalComponent ],
    exports:      [ SimpleIconsAppsignalComponent ],
    bootstrap:    []
})
export class SimpleIconsAppsignalModule {}
